import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=2dca37fe&scoped=true&lang=html&"
import script from "./MenuPage.vue?vue&type=script&lang=js&"
export * from "./MenuPage.vue?vue&type=script&lang=js&"
import style0 from "./MenuPage.vue?vue&type=style&index=0&id=2dca37fe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca37fe",
  null
  
)

export default component.exports